import { Teacher } from "@app/shared/types";
import { Typography } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { CSDialog } from "components/CSDialog";

const useStyles = makeStyles((theme) => ({
    multilineContent: {
        whiteSpace: "pre-line",
        overflowWrap: "break-word",
    },
}));

export const TeacherDialog = (props: {
    onClose: VoidFunction;
    open: boolean;
    teacher: Teacher | null | undefined;
}) => {
    const { onClose, open, teacher } = props;

    const classes = useStyles();

    return (
        <CSDialog onClose={onClose} open={open}>
            {teacher && (
                <>
                    <Typography variant="h3">{teacher.name}</Typography>
                    <Typography variant="body2">
                        Years meditating: {teacher.yearsMeditating} / Years teaching:{" "}
                        {teacher.yearsTeaching}
                    </Typography>
                    <Typography variant="body2">Location: {teacher.location}</Typography>
                    <Typography variant="body2" style={{ marginBottom: 32 }}>
                        Pronouns: {teacher.pronouns}
                    </Typography>
                    <Typography variant="body1">
                        <b>I love working with </b>
                        {teacher.loveWorkingWith}
                    </Typography>
                    <Typography variant="body1">
                        <b>Specialties: </b>
                        {teacher.specialties?.join(", ")}
                    </Typography>
                    <Typography variant="body1">
                        <b>Training and teaching experience: </b>
                        {teacher.training?.join(", ")}
                    </Typography>
                    <Typography variant="body1" className={classes.multilineContent}>
                        {teacher.background}
                    </Typography>
                </>
            )}
        </CSDialog>
    );
};

export default TeacherDialog;
